import React, { memo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

/**
 * Check if the column is a grouped column in AgGrid.
 *
 * @param params - The parameters passed to the cell renderer in AgGrid.
 * @return {boolean} - Returns true if the column is a grouped column, false otherwise.
 */
const isGroupedColumn = (params: ICellRendererParams): boolean =>
    params?.colDef?.colId?.includes('ag-Grid-AutoColumn') || false;

const BottomPinnedRowRenderer = (
    params: ICellRendererParams,
): React.ReactElement => {
    const { t } = useTranslation();
    if (isGroupedColumn(params)) {
        return (
            <Typography
                sx={(theme) => ({
                    fontWeight: 'bold',
                    color: theme.palette.darkGrey,
                    fontSize: '12px',
                })}
            >
                {t('common.total').toUpperCase()}
            </Typography>
        );
    }

    return (
        <Typography
            sx={{
                fontWeight: 'bold',
                fontSize: '11px',
            }}
        >
            {params?.valueFormatted}
        </Typography>
    );
};

export default memo(BottomPinnedRowRenderer);
